import { z } from 'zod';
import { ErrorResponseSchema, SuccessMessageSchema } from '@/schemas/common/base';
import { idValidator } from '@/schemas/common/validators';

/**
 * Delete message parameter schema
 * Validates the chat ID and message ID from the URL path
 */
export const DeleteMessageParamSchema = z.object({
  id: idValidator,
  messageId: idValidator,
});

export type DeleteMessageParam = z.infer<typeof DeleteMessageParamSchema>;

/**
 * Delete message response schema (success or error)
 * Uses discriminatedUnion on 'success' field
 */
export const DeleteMessageResponseSchema = z.discriminatedUnion('success', [
  SuccessMessageSchema,
  ErrorResponseSchema,
]);

export type DeleteMessageResponse = z.infer<typeof DeleteMessageResponseSchema>;
